<template>
	<div style="margin:10px 0px;position: relative;">
		<el-tabs v-model="activeName" @tab-click="handleClick">
			<el-tab-pane :label="$t('accidentStatistics.dailyStatistics')" name="first">
				<el-table :data="daytableData" style="width: 100%;margin-top: 110px;" border :size="size" show-summary :summary-method="getSummaries"  ref="tableRef"
					v-loading="loading">

					<el-table-column prop="CarNo" :label="$t('runState.carNo')" align="center"  fixed="left"> 
					</el-table-column>
					<el-table-column prop="StatisticalDate" :label="$t('runState.statDate')"  align="center"  fixed="left">
					</el-table-column>
					<el-table-column prop="ViolationsNo" :label="$t('violationManagement.violationsNo')" align="center" >
					</el-table-column>
					<el-table-column prop="DeductionValue" :label="$t('violationManagement.deductionvalue')" align="center">
					</el-table-column>

					<el-table-column prop="FineAmount" :label="$t('violationManagement.penaltyamount')+$t('public.unit')" align="center" >
					</el-table-column>
				</el-table>
			</el-tab-pane>
			<el-tab-pane :label="$t('accidentStatistics.monthlyStatistics')" name="second">
				<el-table :data="monthtableData" style="width: 100%;margin-top: 110px;" border v-loading="mloading" :summary-method="getMonthSummaries" ref="tableRef1" show-summary>

					<el-table-column prop="CarNo" :label="$t('runState.carNo')" align="center"  fixed="left">
					</el-table-column>
					<el-table-column prop="StatisticalDate" :label="$t('runState.statMonth')" align="center"  fixed="left">
					</el-table-column>
					<el-table-column prop="ViolationsNo" :label="$t('violationManagement.violationsNo')" align="center">
					</el-table-column>
					<el-table-column prop="DeductionValue" :label="$t('violationManagement.deductionvalue')" align="center">
					</el-table-column>

					<el-table-column prop="FineAmount" :label="$t('violationManagement.penaltyamount')+$t('public.unit')" align="center">
					</el-table-column>
				</el-table>
			</el-tab-pane>
			<el-tab-pane :label="$t('accidentStatistics.overalldaysummary')" name="third">
				<el-table :data="overalldaySummary" style="width: 100%;margin-top: 110px;" border v-loading="odloading" :summary-method="getoveralldaySummaries" ref="tableRef2" 
					:span-method="objectSpanMethod" show-summary>

					<el-table-column prop="GroupName" :label="$t('runState.groupName')" align="center"  fixed="left">
					</el-table-column>
					<el-table-column prop="StatisticalDate" :label="$t('runState.statDate')"  align="center"  fixed="left">
					</el-table-column>
					<el-table-column prop="VelCount" :label="$t('accidentStatistics.vehiclesNo')" align="center">
					</el-table-column>
					<el-table-column prop="ViolationsNo" :label="$t('violationManagement.violationsNo')" align="center">
					</el-table-column>
					<el-table-column prop="DeductionValue" :label="$t('violationManagement.deductionvalue')"  align="center">
					</el-table-column>
					<el-table-column prop="FineAmount" :label="$t('violationManagement.penaltyamount')+$t('public.unit')" align="center">
					</el-table-column>
				</el-table>

			</el-tab-pane>
			<el-tab-pane :label="$t('accidentStatistics.overallmonthsummary')" name="fourth" v-loading="omloading">
				<el-table :data="overallmonthSummary" style="width: 100%;margin-top: 110px;" border  :summary-method="getoverallmonthSummaries" ref="tableRef3"
					 show-summary >

					<el-table-column prop="GroupName" :label="$t('runState.groupName')" align="center" fixed="left">
					</el-table-column>
					<el-table-column prop="StatisticalDate" :label="$t('runState.statMonth')" align="center" fixed="left">
					</el-table-column>
					<el-table-column prop="VelCount" :label="$t('accidentStatistics.vehiclesNo')" align="center">
					</el-table-column>
					<el-table-column prop="ViolationsNo" :label="$t('violationManagement.violationsNo')" align="center">
					</el-table-column>
					<el-table-column prop="DeductionValue" :label="$t('violationManagement.deductionvalue')" align="center">
					</el-table-column>
					<el-table-column prop="FineAmount" :label="$t('violationManagement.penaltyamount')+$t('public.unit')" align="center">
					</el-table-column>
				</el-table>

			</el-tab-pane>
			<el-tab-pane :label="$t('runState.summary')" name="five">
				<el-table :data="overallsummary" style="width: 100%;margin-top: 110px;" border v-loading="osloading">

					<el-table-column prop="GroupName" :label="$t('runState.groupName')" align="center">
					</el-table-column>
					<el-table-column prop="VelCount" :label="$t('accidentStatistics.vehiclesNo')" align="center">
					</el-table-column>
					<el-table-column prop="ViolationsNo" :label="$t('violationManagement.violationsNo')" align="center">
					</el-table-column>
					<el-table-column prop="DeductionValue" :label="$t('violationManagement.deductionvalue')" align="center">
					</el-table-column>
					<el-table-column prop="FineAmount" :label="$t('violationManagement.penaltyamount')+$t('public.unit')" align="center"
					</el-table-column>

				</el-table>
			</el-tab-pane>

		</el-tabs>
		<div class="selectcompany" v-show="showvehicle"
			style="position: absolute;top:50px;margin-left: 450px;font-size: 12px;right:10px">
			<el-form :inline="true" class="demo-form-inline" size="small" style="float: right;">
				<el-form-item :label="$t('maintenancemanagement.carNo')">
					<el-input v-model="veCarNo" :placeholder="$t('maintenancemanagement.inputcarNo')"
						clearable></el-input>
				</el-form-item>
			</el-form>
		</div>
		<div class="selectcompany" v-show="showlevel"
			style="position: absolute;top:50px;margin-left: 450px;font-size: 12px;right:10px">
			<!-- <span class="demonstration">汇总级别：</span>
			<el-cascader size="mini" v-model="value" :options="options" :props="props" collapse-tags clearable
				:show-all-levels="false" @change="handleChange"></el-cascader> -->
			<el-form :inline="true" :size="size" class="form">
				<!-- 汇总级别 -->
				<el-form-item :label="$t('runState.summaryLevel')">
					<el-select v-model="level" :placeholder="$t('public.select')" :size="size"
						@change='levelchangeSelect' style="width:110px;margin-right:6px">
						<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
					<el-select multiple collapse-tags v-model='selectedArray' @change='changeSelect'
						@remove-tag='removeTag' :placeholder="$t('public.select')">
						<el-option :label="$t('accidentStatistics.selectAll')"
							:value="$t('accidentStatistics.selectAll')" @click.native='selectAll'></el-option>
						<el-option v-for='(item, index) in optionslevel[level]' :key='index' :label='item.label'
							:value='item.value'></el-option>
					</el-select>
				</el-form-item>
			</el-form>
		</div>
		<div style="position: absolute;right:10px;top:90px;">
			<generalOrQuickQuery :speedShow="false" @handleQuery="handleQuery" style="text-align: right"
				@childEvent="handleChildEmit" :newsearchType="newsearchType" :key="componentKey"
				@quickQuery="quickQuery" @download="download" />
		</div>

	</div>
</template>

<script>
	import generalOrQuickQuery from '@/views/maintenancemanagement/components/generalOrQuickQuery.vue';
	import {
		mapState
	} from 'vuex';
	export default {
		name:"violationStatistics",
		components: {
			generalOrQuickQuery
		},
		data() {
			return {
				loading: true,
				mloading: true,
				odloading: true,
				omloading: true,
				osloading: true,
				activeName: 'first',
				daytableData: [],
				monthtableData: [],
				overallmonthSummary: [],
				overalldaySummary: [],
				overallsummary: [],
				showlevel: false,
				level: 0,
				veCarNo: "",
				componentKey: 0,
				showvehicle: false,
				options: [{
						value: 0,
						label: this.$t("organstructure.headoffice"),
					},
					{
						value: 1,
						label: this.$t("organstructure.branch"),
					},
					{
						value: 2,
						label: this.$t("runState.fleet"),
					},
					{
						value: 3,
						label: this.$t("runState.route"),
					},
				],
				selectedArray: [],
				optionslevel: [
					[],
					[],
					[],
					[]
				],
				value: [],
				groupIDs: "",
				props: {
					multiple: true
				},

				tabclick: "0",
				// selectvalue: 0,
				newsearchType: 0
			};
		},
		computed: {
			size() {
				return this.$store.getters.size
			},
			...mapState({
				operator: state => state.user.operator,
				vehicles: state => state.app.vehicles,
			}),
		},
		mounted() {
			var that = this;
			console.log(that.vehicles);
			let myDate = new Date();
			that.begindate = that.getNextDate(myDate, -7);
			that.enddate = that.getNextDate(myDate, 0);
			that.statDayPeccancyInfo(that.begindate, that.enddate, 0);
			var newoption = [];
			that.levelchangeSelect(0);
			// that.newvehicles.forEach(element => {
			// 	if (element.treeLevel < 5) {
			// 		newoption.push(element)
			// 	}
			// });
			// that.options = that.convertToCascaderData(newoption);
			// console.log(that.options);

		},
		watch: {
			newsearchType(newVal, oldVal) {
				if (newVal == 1) {
					this.$store.dispatch('app/closeSideBar');
				} else {
					this.$store.dispatch('app/openSideBar');
				}
			}
		},
		methods: {
			handleChildEmit(value) {
				this.newsearchType = value;
			},
			levelchangeSelect(val) {
				this.optionslevel = [
					[],
					[],
					[],
					[]
				];
				this.selectedArray = [];
				this.level = val;
				console.log(val)
				this.$api.queryVehicleTreeInfo({
					OperatorID: this.$store.getters.operator.OperatorId,
					CompanyID: this.$store.getters.operator.CompanyId
				}).then(res => {
					//生成对象，保存到store
					var newvehicles = res.vehicles;
					console.log(res.vehicles);
					newvehicles.forEach(element => {
						if (val == 0 && element.treeLevel == 1) {
							this.optionslevel[0].push({
								value: element.id,
								label: element.name
							})
							this.selectAll();
							console.log(this.selectedArray);
							console.log(25896);
							console.log(this.optionslevel);
						} else if (val == 1 && element.treeLevel == 2) {
							this.optionslevel[1].push({
								value: element.id,
								label: element.name
							})
							console.log(this.optionslevel);
						} else if (val == 2 && element.treeLevel == 3) {
							this.optionslevel[2].push({
								value: element.id,
								label: element.name
							})
							console.log(this.optionslevel);
						} else if (val == 3 && element.treeLevel == 4) {
							this.optionslevel[3].push({
								value: element.id,
								label: element.name
							})
							console.log(this.optionslevel);
						}
					})
				});
			},
			selectAll() {
				if (this.selectedArray.length < this.optionslevel[this.level].length) {
					this.selectedArray = []
					this.optionslevel[this.level].map((item) => {
						this.selectedArray.push(item.value)
					})
					this.selectedArray.unshift(this.$t('accidentStatistics.selectAll'))
				} else {
					this.selectedArray = []
				}
				// this.mulSelecteds = this.selectedArray;
				this.mulSelecteds = this.selectedArray.filter(item => item != this.$t('accidentStatistics.selectAll'));
				this.groupIDs = this.mulSelecteds.join(",");
				// console.log("全选值：" + this.mulSelecteds)
			},
			changeSelect(val) {
				console.log(val)
				if (!val.includes(this.$t('accidentStatistics.selectAll')) && val.length === this.optionslevel[this.level]
					.length) {
					this.selectedArray.unshift(this.$t('accidentStatistics.selectAll'))
				} else if (val.includes(this.$t('accidentStatistics.selectAll')) && (val.length - 1) < this.optionslevel[
						this.level].length) {
					this.selectedArray = this.selectedArray.filter((item) => {
						return item !== this.$t('accidentStatistics.selectAll')
					})
				}
				// this.mulSelecteds = this.selectedArray;
				this.mulSelecteds = this.selectedArray.filter(item => item != this.$t('accidentStatistics.selectAll'));
				this.groupIDs = this.mulSelecteds.join(",");
				console.log(this.mulSelecteds)
			},
			removeTag(val) {
				if (val === this.$t('accidentStatistics.selectAll')) {
					this.selectedArray = []
				}
				this.mulSelecteds = this.selectedArray;
				this.groupIDs = this.mulSelecteds.join(",");
				console.log(this.groupIDs)
			},
			// 将数据重组为el-cascader所需的格式
			convertToCascaderData(regions, parentId = 0) {
				let cascaderData = [];
				regions.forEach(region => {
					if (region.pId === parentId) {
						let children = this.convertToCascaderData(regions, region.id);
						cascaderData.push({
							value: region.id,
							label: region.name,
							children: children.length ? children : undefined,
						});
					}
				});
				return cascaderData;
			},
			download() {
				if ((this.tabclick == "0" && this.daytableData.length == 0) || (this.tabclick == "1" && this.monthtableData
						.length == 0) || (this.tabclick == "2" && this.overalldaySummary.length == 0) || (this.tabclick ==
						"3" && this.overallmonthSummary.length == 0) || (this.tabclick == "4" && this.overallsummary
						.length == 0)) {
					this.$message.info(this.$t("statistics.PleQuery"));
					return;
				}
				this.searchdata(this.begindate, this.enddate, 1);
			},
			getSummaries(param) {
				const {
					columns,
					data
				} = param;
				const sums = [];
				columns.forEach((column, index) => {
					if (index === 0) {
						sums[index] = this.$t('runState.tableSum');
						return;
					}
					const values = data.map(item => Number(item[column.property]));
					if (!values.every(value => isNaN(value))) {
						sums[index] = values.reduce((prev, curr) => {
							const value = Number(curr);
							if (!isNaN(value)) {
								return prev + curr;
							} else {
								return prev;
							}
						}, 0);
						sums[index];
					} else {
						sums[index] = '';
					}
				});
			// 异步将合计栏合并单元格，避免阻塞合计栏数据结构的返回
			this.timer = setTimeout(() => {
				var tablevalue=this.$refs.tableRef.$el;
				this.mergeion(tablevalue);
			}, 50);
				return sums;
			},
			getMonthSummaries(param) {
				const {
					columns,
					data
				} = param;
				const sums = [];
				columns.forEach((column, index) => {
					if (index === 0) {
						sums[index] = this.$t('runState.tableSum');
						return;
					}
					const values = data.map(item => Number(item[column.property]));
					if (!values.every(value => isNaN(value))) {
						sums[index] = values.reduce((prev, curr) => {
							const value = Number(curr);
							if (!isNaN(value)) {
								return prev + curr;
							} else {
								return prev;
							}
						}, 0);
						sums[index];
					} else {
						sums[index] = '';
					}
				});
				// 异步将合计栏合并单元格，避免阻塞合计栏数据结构的返回
				this.timer = setTimeout(() => {
					var tablevalue=this.$refs.tableRef1.$el;
					this.mergeion(tablevalue);
			
				}, 50);
				return sums;
			},
			getoveralldaySummaries(param) {
				const {
					columns,
					data
				} = param;
				const sums = [];
				columns.forEach((column, index) => {
					if (index === 0) {
						sums[index] = this.$t('runState.tableSum');
						return;
					}
					const values = data.map(item => Number(item[column.property]));
					if (!values.every(value => isNaN(value))) {
						sums[index] = values.reduce((prev, curr) => {
							const value = Number(curr);
							if (!isNaN(value)) {
								return prev + curr;
							} else {
								return prev;
							}
						}, 0);
						sums[index];
					} else {
						sums[index] = '';
					}
				});
				// 异步将合计栏合并单元格，避免阻塞合计栏数据结构的返回
				this.timer = setTimeout(() => {
					var tablevalue=this.$refs.tableRef2.$el;
					this.mergeion(tablevalue);
			
				}, 50);
				return sums;
			},
			getoverallmonthSummaries(param) {
				const {
					columns,
					data
				} = param;
				const sums = [];
				columns.forEach((column, index) => {
					if (index === 0) {
						sums[index] = this.$t('runState.tableSum');
						return;
					}
					const values = data.map(item => Number(item[column.property]));
					if (!values.every(value => isNaN(value))) {
						sums[index] = values.reduce((prev, curr) => {
							const value = Number(curr);
							if (!isNaN(value)) {
								return prev + curr;
							} else {
								return prev;
							}
						}, 0);
						sums[index];
					} else {
						sums[index] = '';
					}
				});
				// 异步将合计栏合并单元格，避免阻塞合计栏数据结构的返回
				this.timer = setTimeout(() => {
					var tablevalue=this.$refs.tableRef3.$el;
					this.mergeion(tablevalue);
			
				}, 50);
				return sums;
			},
			mergeion(table) {
				if (table) {
					let current = table.querySelector('.el-table__fixed-footer-wrapper')
						.querySelector('.el-table__footer');
					let cell = current.rows[0].cells;
					console.log(cell[0])
					cell[0].colSpan = '2'; // 前2行都显示累计
					cell[0].style.textAlign = 'center'; // 前2行都显示累计
					cell[1].style.display = 'none';
				}
			},
			flitterData (arr) {
			      let spanOneArr = []
			      let concatOne = 0
			      arr.forEach((item, index) => {
			        if (index === 0) {
			          spanOneArr.push(1);
			        } else {
			          //name 修改
			          if (item.GroupName === arr[index - 1].GroupName) { //第一列需合并相同内容的判断条件
			            spanOneArr[concatOne] += 1;
			            spanOneArr.push(0);
			          } else {
			            spanOneArr.push(1);
			            concatOne = index;
			          };
			        }
			      });
			      return {
			        one: spanOneArr,
			      }
			    },
			    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
			      if (columnIndex === 0) {
			        // this.tableData  修改
			        const _row = (this.flitterData(this.overalldaySummary).one)[rowIndex];
			        const _col = _row > 0 ? 1 : 0;
			        return {
			          rowspan: _row,
			          colspan: _col
			        };
			      }
			    },
			handleClick(tab, event) {
				// console.log(tab, event);
				this.newsearchType = 0;
				this.componentKey += 1;
				this.tabclick = tab.index;
				// this.groupIDs = "";
				this.value = [];
				// let myDate = new Date();
				this.begindate = this.form1.beginDate;
				this.enddate = this.form1.endDate;
				this.searchdata(this.begindate, this.enddate, 0);
			},

			quickQuery(val) {
				this.form1 = val;
				console.log(this.form1)
				delete this.form1.speed;
				delete this.form1.pageNum;
				delete this.form1.pageSize;
				this.begindate = this.form1.beginDate;
				this.enddate = this.form1.endDate;
				this.searchdata(this.begindate, this.enddate, 0);
			},
			handleQuery(val) {
				if(!val.beginDate&&!val.endDate){
					this.$message.warning(this.$t("time.selectQueryTime"));
					return;
				}
				this.form1 = val;
				console.log(this.form1)
				delete this.form1.speed;
				delete this.form1.pageNum;
				delete this.form1.pageSize;
				this.begindate = this.form1.beginDate;
				this.enddate = this.form1.endDate;
				this.searchdata(this.begindate, this.enddate, 0);
			},
			handleChange(value) {
				console.log(value);
				var merged = [...new Set([].concat(...value))];
				console.log(merged);
				this.groupIDs = merged.toString();
			},
			searchdata(begindate, enddate, type) {
				switch (this.tabclick) {
					case "0":
						this.showlevel = false;
						this.showvehicle = true;
						this.statDayPeccancyInfo(begindate, enddate, type);
						break;
					case "1":
						this.showlevel = false;
						this.showvehicle = true;
						this.statMonthPeccancyInfo(begindate, enddate, type);
						break;
					case "2":
						this.showlevel = true;
						this.showvehicle = false;
						this.statDayPeccancyInfoCollect(begindate, enddate, type);
						break;
					case "3":
						this.showlevel = true;
						this.showvehicle = false;
						this.statMonthPeccancyInfoCollect(begindate, enddate, type);
						break;
					case "4":
						this.showlevel = true;
						this.showvehicle = false;
						this.statWholePeccancyInfoCollect(begindate, enddate, type);
						break;
					default:
						break;

				}
			},
			statDayPeccancyInfo(begindate, enddate, type) {
				var that = this;
				that.$api.statDayPeccancyInfo({
					OperatorID: that.operator.OperatorId,
					CarNo: that.veCarNo,
					GroupIDs: that.groupIDs,
					BeginDate: begindate,
					EndDate: enddate,
					IsExport: type
				}).then((res) => {
					if (type == 0) {
						if (res.type == "application/json") {
							const reader = new FileReader();
							reader.readAsText(res, 'utf-8');
							reader.onload = function(e) {
								const readerres = reader.result;
								const parseObj = JSON.parse(readerres);
								console.log(parseObj);
								if (parseObj.data.length > 0) {
									that.daytableData = parseObj.data;
									that.loading = false;

								} else {
									that.daytableData = [];
									that.loading = false;
								}
							}
						}
					} else {
						// that.loading = false;
						let blob = new Blob([res], {
							type: "application/vnd.ms-excel;charset=utf-8"
						}); // 重点代码
						let a = document.createElement("a");
						a.href = window.URL.createObjectURL(blob);
						a.setAttribute("download",that.$t('violationManagement.violationDayStatistics') +
							`_${that.timestampToTime(new Date().getTime())}.xlsx`); // 表名，自定义
						a.click(); // 执行下载
						window.URL.revokeObjectURL(blob); // 释放ur
					}
				})
			},
			statMonthPeccancyInfo(begindate, enddate, type) {
				var that = this;
				that.$api.statMonthPeccancyInfo({
					OperatorID: that.operator.OperatorId,
					CarNo: that.veCarNo,
					GroupIDs: that.groupIDs,
					BeginDate: begindate,
					EndDate: enddate,
					IsExport: type
				}).then((res) => {
					if (type == 0) {
						if (res.type == "application/json") {
							const reader = new FileReader();
							reader.readAsText(res, 'utf-8');
							reader.onload = function(e) {
								const readerres = reader.result;
								const parseObj = JSON.parse(readerres);
								console.log(parseObj);
								if (parseObj.data.length > 0) {
									that.monthtableData = parseObj.data;
									that.mloading = false;

								} else {
									that.monthtableData = [];
									that.mloading = false;
								}
							}
						}
					} else {
						// that.loading = false;
						let blob = new Blob([res], {
							type: "application/vnd.ms-excel;charset=utf-8"
						}); // 重点代码
						let a = document.createElement("a");
						a.href = window.URL.createObjectURL(blob);
						a.setAttribute("download",that.$t('violationManagement.monthviolationStatistics') +
							`_${that.timestampToTime(new Date().getTime())}.xlsx`); // 表名，自定义
						a.click(); // 执行下载
						window.URL.revokeObjectURL(blob); // 释放ur
					}


				})
			},
			statDayPeccancyInfoCollect(begindate, enddate, type) {
				var that = this;
				that.$api.statDayPeccancyInfoCollect({
					OperatorID: that.operator.OperatorId,
					// OperatorID: 7279,
					GroupIDs: that.groupIDs,
					BeginDate: begindate,
					EndDate: enddate,
					IsExport: type
				}).then((res) => {
					if (type == 0) {
						if (res.type == "application/json") {
							const reader = new FileReader();
							reader.readAsText(res, 'utf-8');
							reader.onload = function(e) {
								const readerres = reader.result;
								const parseObj = JSON.parse(readerres);
								console.log(parseObj);
								if (parseObj.data.length > 0) {
									that.overalldaySummary = parseObj.data;
									that.odloading = false;

								} else {
									that.odloading = false;
									that.overalldaySummary = [];
								}
							}
						}
					} else {
						// that.loading = false;
						let blob = new Blob([res], {
							type: "application/vnd.ms-excel;charset=utf-8"
						}); // 重点代码
						let a = document.createElement("a");
						a.href = window.URL.createObjectURL(blob);
						a.setAttribute("download",that.$t('violationManagement.overalldailySummary') +
							`_${that.timestampToTime(new Date().getTime())}.xlsx`); // 表名，自定义
						a.click(); // 执行下载
						window.URL.revokeObjectURL(blob); // 释放ur
					}
				})
			},
			statMonthPeccancyInfoCollect(begindate, enddate, type) {
				var that = this;
				that.$api.statMonthPeccancyInfoCollect({
					OperatorID: that.operator.OperatorId,
					// OperatorID: 7279,
					GroupIDs: that.groupIDs,
					BeginDate: begindate,
					EndDate: enddate,
					IsExport: type
				}).then((res) => {
					if (type == 0) {
						if (res.type == "application/json") {
							const reader = new FileReader();
							reader.readAsText(res, 'utf-8');
							reader.onload = function(e) {
								const readerres = reader.result;
								const parseObj = JSON.parse(readerres);
								console.log(parseObj);
								if (parseObj.data.length > 0) {
									that.overallmonthSummary = parseObj.data;
									that.omloading = false;
								} else {
									that.omloading = false;
									that.overallmonthSummary = [];
								}
							}
						}
					} else {
						let blob = new Blob([res], {
							type: "application/vnd.ms-excel;charset=utf-8"
						}); // 重点代码
						let a = document.createElement("a");
						a.href = window.URL.createObjectURL(blob);
						a.setAttribute("download",that.$t('violationManagement.monthlySummaryviolations') +
							`_${that.timestampToTime(new Date().getTime())}.xlsx`); // 表名，自定义
						a.click(); // 执行下载
						window.URL.revokeObjectURL(blob); // 释放ur
					}

				})
			},
			statWholePeccancyInfoCollect(begindate, enddate, type) {
				var that = this;
				that.$api.statWholePeccancyInfoCollect({
					OperatorID: that.operator.OperatorId,
					// OperatorID: 7279,
					GroupIDs: that.groupIDs,
					BeginDate: begindate,
					EndDate: enddate,
					IsExport: type
				}).then((res) => {
					if (type == 0) {
						if (res.type == "application/json") {
							const reader = new FileReader();
							reader.readAsText(res, 'utf-8');
							reader.onload = function(e) {
								const readerres = reader.result;
								const parseObj = JSON.parse(readerres);
								console.log(parseObj);
								if (parseObj.data.length > 0) {
									that.overallsummary = parseObj.data;
									that.osloading = false;
								} else {
									that.osloading = false;
									that.overallsummary = [];

								}
							}
						}
					} else {
						let blob = new Blob([res], {
							type: "application/vnd.ms-excel;charset=utf-8"
						}); // 重点代码
						let a = document.createElement("a");
						a.href = window.URL.createObjectURL(blob);
						a.setAttribute("download",that.$t('violationManagement.overallSummaryviolations') +
							`_${that.timestampToTime(new Date().getTime())}.xlsx`); // 表名，自定义
						a.click(); // 执行下载
						window.URL.revokeObjectURL(blob); // 释放ur
					}
				})
			},
			//时间戳转换为日期格式
			timestampToTime(timestamp) {
				var date = new Date(timestamp); //时间数为10位篇*1000，时间数为13位的话不需乘1000
				var Y = date.getFullYear();
				var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
				var D = date.getDate();
				var h = date.getHours();
				var m = date.getMinutes();
				var s = date.getSeconds();
				return Y + M + D + h + m + s;
			},
			getNextDate(date, day) {
				const dd = new Date(date);
				dd.setDate(dd.getDate() + day);
				const y = dd.getFullYear();
				const m = dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
				const d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
				return y + "-" + m + "-" + d;
			}
		}
	};
</script>

<style lang="scss" scoped>
	::v-deep .el-tabs__content {
		overflow: visible;
		position: relative
	}

	.el-table {
		font-size: 12px;
	}
</style>